import { Telemetry,ValidTelemetryEvent } from '../commonInfra/services/Telemetry';
import { SiteExpirationParams } from './SiteExpirationNotification';

export enum SiteExpirationEvents {
  BuyLicenses = 'BuyLicenses'
}

// List of SiteExpiration actions. 
export enum SiteExpirationActions {
  RenewDisplay = 'Renew_Display',
  RenewClick = 'Renew_Click',
  SubscribeNowDisplay = 'SubscribeNow_Display',
  SubscribeNowClick = 'SubscribeNow_Click',
  SubscribeNowDisplay1 = 'SubscribeNow_Display_1',
  SubscribeNowClick1 = 'SubscribeNow_Click_1',
  SubscribeNowSubmit = 'SubscribeNow_Submit',
  ContactSaleDisplay = 'ContactSale_Display',
  ContactSaleClick = 'ContactSale_Click'
}

export interface SiteExpirationEvent extends SiteExpirationParams, ValidTelemetryEvent {
  type: SiteExpirationEvents;
  action: SiteExpirationActions;
}

export function sendSiteExpirationTelemetry(action: SiteExpirationActions, params: SiteExpirationParams) {
  Telemetry.sendEvent<SiteExpirationEvent>({
    type: SiteExpirationEvents.BuyLicenses,
    site_uuid: params.site_uuid,
    org62_record_id: params.org62_record_id,
    creators: params.creators,
    explorers: params.explorers,
    viewers: params.viewers,
    action: action
  });
}

